import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleHomeClick = () => {
    navigate('/');
  };

  // Tagline - same for both mobile and desktop
  const tagline = "Cinematic Live Content for Artists, Tours & Live Shows.";

  return (
    <nav
      className="navbar"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        padding: isMobile ? '16px 12px' : '32px 24px',
        margin: 0
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: 'space-between',
          width: '100%',
          margin: 0,
          padding: 0
        }}
      >
        {/* Left spacer for centering */}
        <div style={{ width: isMobile ? '40px' : '80px' }}></div>

        {/* Center title */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <h1
              onClick={handleHomeClick}
              className="navbar-title"
              style={{
                color: '#ffffff',
                fontSize: isMobile ? '18px' : '28px',
                fontWeight: 300,
                fontFamily: 'Montserrat, sans-serif',
                letterSpacing: isMobile ? '0.15em' : '0.2em',
                textTransform: 'uppercase',
                margin: 0,
                padding: 0,
                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                cursor: 'pointer'
              }}
            >
              Joshua Gavin
            </h1>
            <p
              className="tagline"
              style={{
                color: '#ffffff',
                fontSize: isMobile ? '8px' : '15px',
                fontWeight: 400,
                fontFamily: 'Montserrat, sans-serif',
                letterSpacing: isMobile ? '0.08em' : '0.12em',
                margin: '0 auto',
                marginTop: isMobile ? '2px' : '4px',
                padding: 0,
                textShadow: '0 1px 3px rgba(0,0,0,0.8), 0 0 10px rgba(0,0,0,0.5)',
                textAlign: 'center',
                animation: 'fadeIn 2s ease-in-out 0s both'
              }}
            >
              {tagline}
            </p>
          </div>
        </div>

        {/* Right menu icon */}
        <button
          onClick={onMenuClick}
          style={{
            width: isMobile ? '40px' : '80px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: isMobile ? '6px' : '8px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            margin: 0,
            marginTop: isMobile ? '10px' : '0'
          }}
          aria-label="Open menu"
        >
          <span
            style={{
              width: isMobile ? '24px' : '32px',
              height: '2px',
              backgroundColor: '#ffffff',
              display: 'block',
              transition: 'width 0.3s ease',
              boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}
            className="menu-bar"
          ></span>
          <span
            style={{
              width: isMobile ? '24px' : '32px',
              height: '2px',
              backgroundColor: '#ffffff',
              display: 'block',
              transition: 'width 0.3s ease',
              boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}
            className="menu-bar"
          ></span>
          {isMobile && (
            <span
              style={{
                width: '24px',
                height: '2px',
                backgroundColor: '#ffffff',
                display: 'block',
                transition: 'width 0.3s ease',
                boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}
              className="menu-bar"
            ></span>
          )}
        </button>
      </div>

      <style>{`
        /* Fade in effect */
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @media (min-width: 768px) {
          .navbar {
            padding: 40px 48px !important;
          }
          .navbar-title {
            font-size: 32px !important;
          }
          .tagline {
            font-size: 12px !important;
          }
        }

        @media (min-width: 1024px) {
          .navbar {
            padding: 40px 48px !important;
          }
          .navbar-title {
            font-size: 36px !important;
          }
          .tagline {
            font-size: 14px !important;
          }
        }

        button:hover .menu-bar {
          width: 48px !important;
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
